export default "__VITE_ASSET__B4hXd0Ab__"